// Re-export v1 namespace for pattern: import { v1 } from "@stanterprise/protobuf/testsystem"
export * as v1 from './v1/index';
